import { useTranslation } from "react-i18next";

const CelebrationPopup = ({ isVisible, onClose, studentInfo }) => {
  const { t } = useTranslation("general");
  const confettiColors = [
    "#ff6b6b",
    "#4ecdc4",
    "#45b7d1",
    "#f9ca24",
    "#f0932b",
    "#eb4d4b",
  ];

  // Removed auto-close functionality - user controls when to close

  if (!isVisible) return null;

  return (
    <div className="overlay" onClick={onClose}>
      <div className="popup" onClick={(e) => e.stopPropagation()}>
        {/* Confetti */}
        <div className="confetti-container">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="confetti"
              style={{
                backgroundColor: confettiColors[i % 6],
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 0.5}s`,
              }}
            />
          ))}
        </div>

        {/* Graduation Icon */}
        <div className="cap-icon">🎓</div>

        <h2 className="title">🎉 {t("congratulations")} 🎉</h2>

        <p className="message">
          {t("studentGraduatedSuccessfully")} {studentInfo.fullName}
        </p>

        <button className="button" onClick={onClose}>
          ✨ {t("close")}! ✨
        </button>

        {/* Stars */}
        <div className="star top-left-star">⭐</div>
        <div className="star top-right-star">✨</div>
        <div className="star bottom-left-star">🌟</div>
        <div className="star bottom-right-star">💫</div>
      </div>
    </div>
  );
};

export default CelebrationPopup;
